import React, { useState } from 'react';
import { Button, CloseButton, TextButton } from '@fiverr-private/button';
import { Modal, ModalBody, ModalCloseBtn, ModalContent, ModalFooter, ModalHeader } from '@fiverr-private/overlay';
import { DRAWER_CLOSE_BTN_ID } from '@fiverr-private/overlay/src/components/Drawer/constants';
import { useBriefCreationContext } from '../../context/BriefCreationContext';
import { briefCreationClickAction } from '../../monitoring/bqEvents';
import { Step } from '../../constants';
import { AppI18n } from '../../i18n';

interface BriefCreationCloseButtonProps {
  onClose?: () => void;
}

const BriefCreationCloseButton: React.FC<BriefCreationCloseButtonProps> = ({ onClose }) => {
  const { currentStep, contextId, userInput, source, variant, setIsOpen, parentElement } = useBriefCreationContext();

  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);

  const handleCloseModal = () => {
    setIsConfirmModalOpen(false);
  };

  const closeBriefCreationDrawer = () => {
    setIsConfirmModalOpen(false);
    setIsOpen(false);
    onClose?.();
  };

  const onCloseBriefClicked = () => {
    briefCreationClickAction({
      step: currentStep,
      action: 'X',
      briefContextId: contextId,
      eventSource: source || '',
      variant,
      parentElement,
    });

    const firstStepWithUserInput = currentStep === Step.Creation && !!userInput?.length;
    const otherMeaningfulStep = ![Step.Error, Step.Finish, Step.Creation, Step.ComingSoon].includes(currentStep);

    if (firstStepWithUserInput || otherMeaningfulStep) {
      setIsConfirmModalOpen(true);
    } else {
      closeBriefCreationDrawer();
    }
  };

  const CloseButtonComponent = () => {
    if (variant === 'onboarding_routing') {
      return (
        <TextButton onClick={onCloseBriefClicked} size={{ default: 'sm', sm: 'md' }}>
          <AppI18n k="exit" />
        </TextButton>
      );
    }

    return <CloseButton size="md" color="dark" onClick={onCloseBriefClicked} />;
  };

  return (
    <>
      <Modal isOpen={isConfirmModalOpen} onClose={handleCloseModal}>
        <ModalContent>
          <ModalHeader>
            <AppI18n k="delete_modal.title" />
            <ModalCloseBtn />
          </ModalHeader>
          <ModalBody>
            <AppI18n k={'delete_modal.description'} />
          </ModalBody>
          <ModalFooter>
            <Button variant="ghost" onClick={handleCloseModal}>
              <AppI18n k="delete_modal.cancel" />
            </Button>
            <Button onClick={closeBriefCreationDrawer} colorScheme="red">
              <AppI18n k="delete_modal.delete" />
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      <CloseButtonComponent />
    </>
  );
};

BriefCreationCloseButton.displayName = 'DrawerCloseButton';

// Mimic the drawer close button so the drawer header handles it natively
Object.assign(BriefCreationCloseButton, {
  id: DRAWER_CLOSE_BTN_ID,
});

export default BriefCreationCloseButton;
